'use client';
import { SHORTCUT_YIELD, useRegisterShortcut, } from '#pplx/frontend/apps/ask/keyboard-shortcuts-provider/registry.js';
import { useInputActions } from '#pplx/frontend/apps/ask/stores/queryInput.js';
import { DomHelper } from '#pplx/frontend/components/utils/domHelpers.js';
import { useCallback } from 'react';
/**
 * Registers the **Focus Ask Input** global shortcuts:
 *   - macOS: Cmd+J  /  Windows/Linux: Ctrl+J
 *   - All platforms: `/` (bare key, works across keyboard layouts)
 *
 * Keybinding, label, and group are resolved from the shortcut manifest.
 *
 * Triggers focus on the ask input via the `shouldTriggerFocus` store flag.
 * Skips when any input element is already focused to avoid stealing focus
 * from other editable fields. Bare `/` yields to a Composer with `typeToFocus`,
 * which types it natively; the shortcut goes away once Composer replaces AskInput.
 */
export function useFocusAskInputShortcut() {
    const { setShouldTriggerFocus } = useInputActions();
    const handler = useCallback((e) => {
        // Only bare `/` yields: Composer types it natively. Cmd/Ctrl+J keeps the
        // default prevented so the browser does not open its Downloads panel.
        const hasModifier = e.metaKey || e.ctrlKey || e.altKey;
        if (!hasModifier && document.querySelector('[data-type-to-focus]') !== null) {
            return SHORTCUT_YIELD;
        }
        if (DomHelper.isAnyInputElementFocused())
            return;
        // Prevent the browser default so the keypress only focuses the ask
        // input. For Cmd+J / Ctrl+J this suppresses Chrome's "Downloads"
        // panel; for `/` it stops the character from being inserted into any
        // element that receives focus as a side-effect.
        e.preventDefault();
        setShouldTriggerFocus(true);
    }, [setShouldTriggerFocus]);
    useRegisterShortcut({ id: 'focus-ask-input', handler });
}
//# sourceMappingURL=useFocusAskInputShortcut.js.map